import messagesEN from '../../features/translations/en-GB.json';
import { CHANGE_LOCALE, LANGUAGE_DATA_FETCHED } from './actions';
import { getSupportedLocale } from './lang';

const applyLocale = (state, preferredLocale) => {
    const { allMessages } = state;
    const displayLocale = getSupportedLocale(preferredLocale);
    const displayMessages = allMessages[displayLocale];

    return {
        allMessages,
        displayLocale,
        displayMessages,
    };
};

const mergeLanguageData = (allMessages, languageData, locale) => {
    return {
        ...allMessages,
        [locale]: languageData,
    };
};

const defaultMessages = {
    'en-GB': messagesEN,
};

export const defaultLanguageState = {
    allMessages: defaultMessages,
    displayMessages: null,
    displayLocale: null,
};

export default function langReducer(state = defaultLanguageState, action = {}) {
    switch (action.type) {
        case CHANGE_LOCALE: {
            return {
                ...state,
                ...applyLocale(state, action.payload),
            };
        }
        case LANGUAGE_DATA_FETCHED: {
            const { locale, languageData } = action.payload;

            return {
                allMessages: mergeLanguageData(state.allMessages, languageData, locale),
                displayMessages: languageData,
                displayLocale: locale,
            };
        }
        default:
            return state;
    }
}
